import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useOnClickToggleSection } from "../Hooks/useOnClickToggleSection";
import type { ButtonProps } from "./Button";

export interface SettingsButtonProps extends ButtonProps {
  shouldKeepSidebarOpen?: boolean;
}

export const SettingsButton = ({
  shouldKeepSidebarOpen = false,
  className,
  ...rest
}: SettingsButtonProps) => {
  const onClickHandler = useOnClickToggleSection({
    viewName: "settings",
    shouldKeepSidebarOpen,
  });

  return (
    <IconButton
      name="16-settings"
      iconSize={16}
      ariaLabel={t("settings")}
      className={classNames(className)}
      onClick={onClickHandler}
      data-testid="builder-ui-settings-button"
      {...rest}
    />
  );
};
